import React from "react";
import { IconPreview, IconRules } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const scrollbarTokens = [
  { token: "--ds-scrollbar-thumb", value: "border-emphasis", usage: "Der Griff selbst." },
  { token: "--ds-scrollbar-track", value: "transparent", usage: "Die Bahn bleibt leer — sichtbar ist nur der Griff." },
  { token: "--ds-scrollbar-thumb-hover", value: "neutral-600", usage: "Griff unter dem Zeiger (nur Rückfallebene)." },
  { token: "--ds-scrollbar-size", value: "6px", usage: "Breite bzw. Höhe — nur in der ::-webkit-Rückfallebene wirksam." },
  { token: "--ds-scrollbar-radius", value: "radius-pill", usage: "Rundung des Griffs — ebenfalls nur in der Rückfallebene." },
];

const utilityClasses = [
  { name: ".ds-scroll", usage: "Scroll-Container in beide Richtungen." },
  { name: ".ds-scroll--y", usage: "Nur senkrecht, waagrecht wird abgeschnitten." },
  { name: ".ds-scroll--x", usage: "Nur waagrecht, senkrecht wird abgeschnitten." },
  { name: ".ds-scroll--gutter", usage: "Hält den Platz des Balkens frei, damit der Inhalt nicht springt." },
  { name: ".ds-scroll--hidden", usage: "Scrollen ohne sichtbaren Balken — nur mit eigener Bedienung daneben." },
];

const LONG_TEXT = [
  "Erste Zeile im Scroll-Bereich",
  "Zweite Zeile",
  "Dritte Zeile",
  "Vierte Zeile",
  "Fünfte Zeile",
  "Sechste Zeile",
  "Siebte Zeile",
  "Achte Zeile",
];

function TokenRow({ item }) {
  return (
    <div className="ds-docs-scrollbar-token">
      <div className="ds-docs-scrollbar-token__meta">
        <code>{item.token}</code>
        <span>{item.value}</span>
      </div>
      <div className="ds-docs-scrollbar-token__usage">{item.usage}</div>
    </div>
  );
}

export default function ScrollbarsDocs() {
  return (
    <DocsSectionCard title="Scrollbars">
      <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--scrollbars">
        <DocsPreviewPanel label="Vorschau" icon={IconPreview}>
          <div className="ds-docs-preview-surface ds-docs-scrollbar-sheet">
            <div className="ds-docs-scrollbar-demo">
              <span className="ds-docs-scrollbar-demo__label">senkrecht · .ds-scroll--y</span>
              <div className="ds-scroll ds-scroll--y ds-docs-scrollbar-demo__box">
                {LONG_TEXT.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
            </div>

            <div className="ds-docs-scrollbar-demo">
              <span className="ds-docs-scrollbar-demo__label">waagrecht · .ds-scroll--x</span>
              <div className="ds-scroll ds-scroll--x ds-docs-scrollbar-demo__box">
                <div className="ds-docs-scrollbar-demo__wide">
                  Ein Inhalt, der breiter ist als sein Container und deshalb waagrecht scrollt.
                </div>
              </div>
            </div>

            <div className="ds-docs-scrollbar-demo">
              <span className="ds-docs-scrollbar-demo__label">beide · .ds-scroll</span>
              <div className="ds-scroll ds-docs-scrollbar-demo__box">
                <div className="ds-docs-scrollbar-demo__wide">
                  {LONG_TEXT.map((line) => (
                    <p key={line}>{line} — und dazu noch deutlich mehr Breite als der Container hergibt.</p>
                  ))}
                </div>
              </div>
            </div>

            <div className="ds-docs-scrollbar-demo">
              <span className="ds-docs-scrollbar-demo__label">ohne Balken · .ds-scroll--hidden</span>
              <div className="ds-scroll ds-scroll--y ds-scroll--hidden ds-docs-scrollbar-demo__box">
                {LONG_TEXT.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </div>
            </div>
          </div>
        </DocsPreviewPanel>

        <DocsPreviewPanel label="Tokens" icon={IconRules}>
          <div className="ds-docs-preview-surface ds-docs-scrollbar-sheet">
            {scrollbarTokens.map((item) => (
              <TokenRow key={item.token} item={item} />
            ))}
          </div>
        </DocsPreviewPanel>

        <DocsPreviewPanel label="Klassen" icon={IconRules}>
          <div className="ds-docs-preview-surface ds-docs-scrollbar-sheet">
            {utilityClasses.map((item) => (
              <div className="ds-docs-scrollbar-token" key={item.name}>
                <div className="ds-docs-scrollbar-token__meta">
                  <code>{item.name}</code>
                </div>
                <div className="ds-docs-scrollbar-token__usage">{item.usage}</div>
              </div>
            ))}
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow
          intro="Wichtigste Regeln:"
          items={[
            "Das Aussehen gilt global — auch für Container, die uns nicht gehören (MUI-Menüs, Syncfusion). Niemand definiert eigene Scrollbalken.",
            "Wer einen Scroll-Container aufmacht, nimmt .ds-scroll (bzw. --x / --y). Damit steht auch min-height: 0, ohne das Scroll-Container in Flex-Layouts nicht schrumpfen.",
            ".ds-scroll--gutter überall dort, wo der Inhalt zwischen scrollend und nicht scrollend wechselt — sonst springt das Layout um die Balkenbreite.",
            "Die Bahn ist bewusst leer: Ein graues Band neben jeder Liste macht das Layout unruhig.",
            "scrollbar-width/-color und ::-webkit-scrollbar schliessen sich gegenseitig aus: Sobald die Standard-Eigenschaften gesetzt sind, ignoriert Chrome die ::-webkit-Regeln. Deshalb führt der Standardweg, ::-webkit bleibt reine Rückfallebene.",
          ]}
        />
      </div>
    </DocsSectionCard>
  );
}
